import { authFetch } from '../../common/networking/auth-fetch'
import { ManagedProduct } from '../../types/products/managed-product.schema';
import { ProductResponse } from '../../types/products/product-response'
import { SkinsPaginationResponse } from '../../types/products/skins-pagination-response'

export interface ProductFormData {
  images?: File[];
  categoryKey?: string;
  sellingChannelKeys: string[];
  title: string;
  price: string;
  compareAtPrice: string | null;
  description: string;
  metafields: Record<string, unknown>;
}

/**
 * Create a managed product owned by the user.
 */
export async function createMyProduct(data: ProductFormData, accessToken?: string): Promise<ManagedProduct> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/my`,
    data,
  );
  return await response.json();
}

/**
 * Update a managed product owned by the user.
 */
export async function updateProduct(id: number, data: ProductFormData, accessToken?: string): Promise<ManagedProduct> {
  const response = await authFetch(accessToken).patch(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/${id}`,
    data,
  );
  return await response.json();
}

/**
 * Get products owned by the user.
 */
export async function getMyProducts(accessToken?: string): Promise<ProductResponse[]> {
  const response = await authFetch(accessToken).get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/me`,
  )
  return await response.json();
}

export async function getProducts(): Promise<ProductResponse[]> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products?type=gift card`,
  )
  return await response.json()
}

export async function getProductCategories(): Promise<string[]> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/categories`,
  )
  return await response.json()
}

export async function getProductByCategoriesAndSlug(
  gamekey: string,
  slug: string,
): Promise<ProductResponse> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/categories/${gamekey}/seo-slugs/${slug}`,
  )
  return await response.json()
}

export async function getProductsByCategoryKey(
  gamekey: string,
): Promise<ProductResponse[]> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/by-key/${gamekey}`,
  )
  return await response.json()
}

export async function getProductStreamer(
  gamekey: string,
): Promise<ProductResponse[]> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/products/streamers?gameKey=${gamekey}`,
  )
  return await response.json()
}

export async function getSkinById(
  accessToken: any,
  pageParam: number,
  productId: number,
  q: string,
): Promise<SkinsPaginationResponse> {
  let url = `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/skins/products/${productId}`

  const queryParams = []
  if (pageParam !== null && pageParam !== undefined) {
    queryParams.push(`page=${pageParam}`)
  }

  if (q !== null && q !== undefined && q.trim() !== '') {
    queryParams.push(`q=${q}`)
  }

  if (queryParams.length) {
    url += `?${queryParams.join('&')}`
  }

  const response = await authFetch(accessToken).get(url)
  return await response.json()
}
